<app-sigt-spatial-filter-type [store]="spatialListStore"
    [selectedQueryType]="queryType"
    [zone]="zone"
    [layers]="activeLayers"
    [selectedTabIndex]="coords ? 1 : 0"
    [activeDrawType]="coords ? spatialType.Point : spatialType.Polygon"
    (eventType)="getOutputType($event)"
    (eventQueryType)="getOutputQueryType($event)"
    (zoneChange)="onZoneChange($event)"
    (zoneWithBufferChange)="onZoneChange($event, true)"
    (bufferChange)="buffer = $event"
    (measureUnitChange)="measureUnit = $event">
</app-sigt-spatial-filter-type>

<app-sigt-spatial-filter-item [type]="type"
    [queryType]="queryType"
    [map]="map"
    [zone]="zone"
    [loading]="loading"
    [store]="store"
    [layers]="activeLayers"
    [allLayers]="layers"
    [thematicLength]="thematicLength"
    (radiusEvent)="buffer = $event"
    (bufferEvent)="buffer = $event"
    (measureUnitChange)="measureUnit = $event"
    (drawZoneEvent)="zone = $event"
    (zoneWithBufferChange)="onZoneChange($event, true)"
    (itemTypeChange)="itemType = $event"
    (thematicChange)="thematics = $event"
    (toggleSearch)="getOutputToggleSearch()"
    (clearButtonEvent)="clearMap()"
    (clearSearchEvent)="getOutputClearSearch()"
    (export)="activateExportTool()"
    (openWorkspace)="activateWorkspace()"
    (entityChange)="activateWorkspace($event)">
</app-sigt-spatial-filter-item>